/**
 * Default CSS `scale()` factor applied to the left and right (non-active) cards.
 * At 0.8, side cards appear at 80% of the center card's size, creating a
 * subtle depth/perspective effect. Can be overridden via the `sideScale` prop
 * on `<RotationalCarousel>`.
 */
const DEFAULT_SIDE_SCALE = 0.8;

/**
 * Default distance in pixels from the container's horizontal center to the
 * visual center of each side card. Controls how spread-out the three visible
 * cards appear — increase to push side cards further apart, decrease to bring
 * them closer. Can be overridden via the `sideOffset` prop on `<RotationalCarousel>`.
 */
const DEFAULT_SIDE_OFFSET = 160;

/**
 * CSS transition string applied to every carousel item's `style` attribute.
 */
const SLOT_TRANSITION =
  "transform 0.45s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s ease";

export { DEFAULT_SIDE_SCALE, DEFAULT_SIDE_OFFSET, SLOT_TRANSITION };
